import { createContext, useContext } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "./dropdown-menu";
import { MobileSheet, MobileSheetBody, MobileSheetClose, MobileSheetCloseButton, MobileSheetContent, MobileSheetHeader, MobileSheetTitle, MobileSheetTrigger } from "./mobile-sheet";
import useIsMobile from "../../hooks/useIsMobile";

const MobileContext = createContext(false);

export function ResponsiveDropdownMenu(props) {
  const mobile = useIsMobile();
  const Root = mobile ? MobileSheet : DropdownMenu;
  return <MobileContext.Provider value={mobile}><Root {...props} /></MobileContext.Provider>;
}

export function ResponsiveDropdownMenuTrigger(props) {
  const mobile = useContext(MobileContext);
  const Trigger = mobile ? MobileSheetTrigger : DropdownMenuTrigger;
  return <Trigger {...props} />;
}

export function ResponsiveDropdownMenuContent({ title = "Actions", align, className = "", children, ...props }) {
  const mobile = useContext(MobileContext);
  if (mobile) return (
    <MobileSheetContent aria-describedby={undefined} {...props}>
      <MobileSheetHeader>
        <MobileSheetTitle>{title}</MobileSheetTitle>
        <MobileSheetCloseButton />
      </MobileSheetHeader>
      <MobileSheetBody className={`${className} !w-auto !max-w-none`}><div className="space-y-1">{children}</div></MobileSheetBody>
    </MobileSheetContent>
  );
  return <DropdownMenuContent align={align} className={className} {...props}>{children}</DropdownMenuContent>;
}

export function ResponsiveDropdownMenuItem({ className = "", disabled, children, onClick, ...props }) {
  const mobile = useContext(MobileContext);
  if (mobile) return (
    <MobileSheetClose asChild>
      <button type="button" disabled={disabled} onClick={onClick}
        className={`flex w-full items-center rounded-lg px-3 py-3 text-left text-sm hover:bg-slate-100 disabled:opacity-50 disabled:pointer-events-none ${className}`} {...props}>
        {children}
      </button>
    </MobileSheetClose>
  );
  return <DropdownMenuItem className={className} disabled={disabled} onClick={onClick} {...props}>{children}</DropdownMenuItem>;
}

export function ResponsiveDropdownMenuSeparator(props) {
  const mobile = useContext(MobileContext);
  return mobile ? <div className="my-2 border-t border-slate-100" {...props} /> : <DropdownMenuSeparator {...props} />;
}
